import styled from "@emotion/styled/macro";
import { colors, shadows } from "../../../../common/styles/theme.styles";
import { PrimaryButton } from "../../../../common/components/buttons/NewButtons.styles";

export const Overlay = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    z-index: 1000;
    transition: opacity 0.2s ease-out;
    src/modules/vault
`;

export const MetadataPanelWrapper = styled.div`
    ${({ isDesktop, isAssetVaultTab, isMobileFullScreen, isSideMenuMinimized }) => isDesktop ? `
        position: sticky;
        top: 0px;
        width: 424px;
        min-width: 424px;
        height: fit-content;
        max-height: 100%;
        background: #FFFFFF;
        flex-shrink: 0;
        border-radius: 12px;
        box-shadow: ${shadows.cardShadow};
        transform: translateX(0);
        transition: transform 0.25s ease-out, opacity 0.2s ease-out;
        overflow-y: auto;
    ` : isMobileFullScreen ? `
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        background: #FFFFFF;
        overflow: hidden;
    ` : `
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%) scale(1);
        width: 90vw;
        max-width: 424px;
        max-height: 90vh;
        background: #FFFFFF;
        border-radius: 12px;
        box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.04), 0px 1px 4px 0px rgba(0, 0, 0, 0.08);
        z-index: 1001;
        overflow-y: auto;
        transition: transform 0.25s ease-out, opacity 0.2s ease-out;
        ${isAssetVaultTab && !isSideMenuMinimized ? `
            margin-left: 130px;
        ` : ``}
    `}
    
    &.panel-enter {
        ${({ isDesktop, isMobileFullScreen }) => isDesktop ? `
            transform: translateX(100%);
            opacity: 0;
        ` : isMobileFullScreen ? `
            transform: translateX(100%);
            opacity: 0;
        ` : `
            transform: translate(-50%, -50%) scale(0.95);
            opacity: 0;
        `}
    }
    
    &.panel-enter-active {
        ${({ isDesktop, isMobileFullScreen }) => isDesktop ? `
            transform: translateX(0);
            opacity: 1;
        ` : isMobileFullScreen ? `
            transform: translateX(0);
            opacity: 1;
        ` : `
            transform: translate(-50%, -50%) scale(1);
            opacity: 1;
        `}
    }
    
    &.panel-exit {
        ${({ isDesktop, isMobileFullScreen }) => isDesktop ? `
            transform: translateX(0);
            opacity: 1;
        ` : isMobileFullScreen ? `
            transform: translateX(0);
            opacity: 1;
        ` : `
            transform: translate(-50%, -50%) scale(1);
            opacity: 1;
        `}
    }
    
    &.panel-exit-active {
        ${({ isDesktop, isMobileFullScreen }) => isDesktop ? `
            transform: translateX(100%);
            opacity: 0;
        ` : isMobileFullScreen ? `
            transform: translateX(100%);
            opacity: 0;
        ` : `
            transform: translate(-50%, -50%) scale(0.95);
            opacity: 0;
        `}
    }
`;

export const MetadataPanelContent = styled.div`
    display: flex;
    flex-direction: column;
    padding: 16px 20px 24px;
    gap: 12px;
    
    ${({ isMobileFullScreen }) => isMobileFullScreen && `
        padding: 0;
        height: 100%;
    `}
`;

export const MobileMetadataHeader = styled.div`
    display: flex;
    align-items: center;
    padding: 12px 16px;
    background: #FFFFFF;
    border-bottom: 1px solid #E5E7EB;
    gap: 12px;
`;

export const MobileBackButton = styled.button`
    display: flex;
    align-items: center;
    justify-content: center;
    border: none;
    background: transparent;
    cursor: pointer;
    border-radius: 8px;
    svg {
        path {
            stroke: ${colors.darkGray1};
        }
    }
`;

export const MobileMetadataContent = styled.div`
    flex: 1;
    padding: 16px 20px 24px;
    gap: 12px;
    display: flex;
    flex-direction: column;
    overflow-y: auto;
`;
export const FileHeader = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
    background: #FFFFFF;
    border-radius: 12px;
`;

export const FileHeaderTop = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 0 0 4px;
`;

export const CloseButton = styled.button`
    display: flex;
    justify-content: center;
    align-items: center;
    border: none;
    cursor: pointer;
    padding: 0;
    
    width: 32px;
    height: 32px;
    background: #fff;
    border-radius: 24px;
    color: ${colors.darkGray2};
    
    &:hover {
        background: ${colors.lightGray2};
    }
    
    svg {
        width: 32px;
        height: 32px;
    }

`;

export const FileHeaderTitleEditButtonWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-width: 16px;
`;

export const FileHeaderTitleEditButton = styled.div`
    display: none;
    align-items: center;
    justify-content: center;
    height: 100%;
`;

export const FileHeaderTitleWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
    background: #FFFFFF;
    border-radius: 12px;
`;

export const FileHeaderTitle = styled.div`
    display: flex;
    gap: 4px;
    padding: 6px 16px 8px 12px;

    border-radius: 12px;
    border: 1px solid transparent;

    ${({ isEditingName }) => isEditingName && `
    padding: 6px 0 0 0;
    `}

    ${({ isEditingName }) => !isEditingName && `
        :hover, :active {
            border-color: #DDE3EB;
            cursor: pointer;

            ${FileHeaderTitleEditButton}{
                display: flex;
            }
        }
    `}
`;


export const FileInfoSubTitle = styled.div`
    display: none;
    justify-content: space-between;
    color: var(--Dark-Gray-3, #9097A3);
    font-size: 12px;
    font-style: normal;
    font-weight: 450;
    line-height: normal;

    width: 100%;
`;

export const RequiredText = styled.div`
    color: #F00;
`;

export const FileHeaderTitleInfo = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    flex: 1 0 0;
`;

export const FileTitleWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    flex: 1 0 0;
    width: 100%;


    ${({ isEditingName, isInvalid }) => isEditingName && `
        ${FileInfoSubTitle} {
            display: flex;
        }

        border: 1px solid ${isInvalid ? '#F00' : '#1A1B1D'};
        padding: 12px 16px;
        gap: 2px;
        border-radius: 12px 12px 0 0;
        width: 100%;
    `}
`;

export const FileTitle = styled.div`
    font-family: Circular;
    font-weight: 500;
    font-size: 14px;
    line-height: 1.265;
    color: ${colors.darkGray1};
`;

export const FileDescriptionWrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    align-self: stretch;

    ${({ isEditingName }) => isEditingName && `
    
        ${FileInfoSubTitle} {
            display: block;
        }

        border: 1px solid #DDE3EB;
        border-top: none;
        border-radius: 0 0 12px 12px;
        width: 100%;
        padding: 10px 16px 16px 16px;
        gap: 2px;
    `}
`;

export const FileNameEditButtonsGroup = styled.div`
    display: flex;
    padding-top: 4px;
    align-items: flex-start;
    justify-content: flex-end;
    gap: 4px;
    padding-bottom: 16px;
`;

export const FileNameEditButton = styled.div`
    display: flex;
    width: 104px;
    height: 36px;
    padding: 0px 16px 1px 16px;
    justify-content: center;
    align-items: center;
    gap: 8px;

    border-radius: 10px;

    font-size: 14px;
    font-style: normal;
    font-weight: 450;
    line-height: normal;

    cursor: pointer;
    
`;

export const FileNameEditSaveButton = styled(FileNameEditButton)`
    background: var(--Main-Colors-Dark-Grey-1, #1A1B1D);
    color: var(--White, #FFF);

    ${({ disabled }) => disabled && `
        pointer-events: none;
        opacity: 0.5;
        cursor: not-allowed;
    `}
`;

export const FileNameEditCancelButton = styled(FileNameEditButton)`
    border: 1px solid var(--Main-Colors-Grey-3, #DDE3EB);
`;

export const ButtonsWrapper = styled.div`
    display: flex;
    gap: 12px;
    padding-top: 2px;
`;

export const ActionButton = styled.button`
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 8px;
    padding: 8px;
    height: 40px;
    flex: 1;
    border-radius: 10px;
    border: none;
    cursor: pointer;
    font-family: Circular;
    font-weight: 450;
    font-size: 13px;
    line-height: 1.265;
    background: #FFFFFF;
    color: ${colors.darkGray1};
    border: 1px solid transparent;
    box-shadow: 0px 0px 2px 0px rgba(0, 0, 0, 0.16), 0px 2px 4px 0px rgba(0, 0, 0, 0.04);
    transition: all 0.2s ease;
    
    &:hover {
        border: 1px solid ${colors.darkGray2};
    }
    
    svg {
        width: 16px;
        height: 16px;
    }
`;

export const DownloadButton = styled(ActionButton)`
    font-size: 14px;
    line-height: 1.265;
    svg {
        width: 24px;
        height: 24px;
    }
`;

export const DeleteButton = styled(ActionButton)`
    font-size: 14px;
    line-height: 1.265;
    svg {
        width: 24px;
        height: 24px;
    }
    &:hover {
        border: 1px solid #ff0000;
        color: #ff0000;
        svg {
            path {
                stroke: #ff0000;
            }
        }
    }
`;

export const CheckmarkIcon = () => {
    return (
        <svg width="16" height="16" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="9" cy="9" r="8" fill="#6EBA7F" />
            <path d="M5.25 9L7.5 11.25L12.75 6" stroke="#FFFFFF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
};

export const DoneButton = styled(PrimaryButton)`
    margin-top: 12px;
    border-radius: 12px;
    height: 48px;
    font-size: 16px;
    font-weight: 450;
    font-family: Circular;
`;